import { Box, Button } from '@chakra-ui/react';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactExport from 'react-export-excel';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import useStore from '../../../../store';
import getDepartmentLabel from '../../../../utils/getDepartmentLabel';
import getOfficeLabel from '../../../../utils/getOfficeLabel';
import c from '../../../../constant';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export default function ExportExcelOfficialsPosition({ employees = [], notes = {}, ...props }) {
	const { t } = useTranslation();
	const { currentLang: lang } = useStore((state) => state.currentLang);

	const formatDateOrDash = (date) => {
		if (!date || !moment(date).isValid()) {
			return '-';
		}

		return moment(date).format('DD MMM YYYY');
	};

	const getPositionDate = (employee, position) => {
		const records = employee?.positionStatuses || [];

		const positionRecord = records.find((record) => record?.position === position);

		if (positionRecord?.dateOfLastPosition) {
			return formatDateOrDash(positionRecord.dateOfLastPosition);
		}

		return '-';
	};

	const data = employees?.map((employee, index) => {
		const positionStatuses = employee?.positionStatuses || [];

		const statuedOfficerRecord =
			employee?.latestPositionStatus?.position === '7' ? employee?.latestPositionStatus : positionStatuses.find((record) => record?.position === '7');

		const statuedOfficerDate = statuedOfficerRecord?.dateOfLastPosition
			? formatDateOrDash(statuedOfficerRecord?.dateOfLastPosition)
			: employee?.currentWorkingStatus?.currentWorkingStatusPosition === '7'
				? formatDateOrDash(employee?.currentWorkingStatus?.currentWorkingStatusDateOfChangePosition)
				: '-';

		return {
			number: index + 1,
			fullNameKhmer: employee?.fullName || '-',
			fullNameEnglish: employee?.fullNameLatin || '-',
			department: employee?.department ? t(getDepartmentLabel(employee?.department)) : '-',
			office: employee?.office ? t(getOfficeLabel(employee?.office)) : '-',
			gender: employee?.gender ? t(employee?.gender) : '-',
			dob: formatDateOrDash(employee?.dob),
			// employmentDate: formatDateOrDash(employee?.createdAt),
			statuteOfficerDate: statuedOfficerDate,

			level2: getPositionDate(employee, '7'),
			level3: getPositionDate(employee, '6'),
			level4: getPositionDate(employee, '5'),
			level5: getPositionDate(employee, '4'),
			level6: getPositionDate(employee, '3'),
			level7: getPositionDate(employee, '2'),
			level8: getPositionDate(employee, '1'),

			employmentStatusDate: employee?.active === false ? formatDateOrDash(employee?.employmentStatusDate) : '-',
			note: notes?.[employee?.id] || '-',
		};
	});

	const now = moment().format(c.dateTimeFormat);
	const filename = lang === 'kh' ? `បញ្ជីមុខតំណែងមន្ត្រី_${now}` : `Officials_Position_List_${now}`;

	return (
		<Box {...props}>
			<ExcelFile
				filename={filename}
				element={
					<Button
						leftIcon={<FontAwesomeIcon icon={faFileExcel} style={{ fontSize: 16 }} />}
						colorScheme="gray"
						variant="solid"
						size="sm"
						borderRadius={c.borderRadius}
						border="1px solid #bdc3c7"
					>
						{t('Export')}
					</Button>
				}
			>
				<ExcelSheet data={data} name={t('Officials Position List')}>
					<ExcelColumn label={t('Number')} value="number" />

					<ExcelColumn label={t('Fullname (Khmer)')} value="fullNameKhmer" />

					<ExcelColumn label={t('Fullname (Latin)')} value="fullNameEnglish" />

					<ExcelColumn label={t('Department')} value="department" />

					<ExcelColumn label={t('Office')} value="office" />

					<ExcelColumn label={t('Gender')} value="gender" />

					<ExcelColumn label={t('Date of birth')} value="dob" />

					<ExcelColumn label={t('Date of Employment')} value="employmentDate" />

					{/* <ExcelColumn label={t('Date as Statute Officer')} value="statuteOfficerDate" /> */}

					<ExcelColumn label={t('Statute Officer')} value="level2" />

					<ExcelColumn label={t('Deputy Head of Office')} value="level3" />

					<ExcelColumn label={t('Head of Office')} value="level4" />

					<ExcelColumn label={t('Deputy Head of Department')} value="level5" />

					<ExcelColumn label={t('Head of Department')} value="level6" />

					<ExcelColumn label={t('Deputy Director General')} value="level7" />

					<ExcelColumn label={t('Director General')} value="level8" />

					<ExcelColumn label={t('Resignation Date')} value="employmentStatusDate" />

					<ExcelColumn label={t('ព្រះរាជក្រឹត្យលេខ/អនុក្រឹត្យលេខ/ប្រកាសលេខ/ផ្សេងៗ')} value="note" />
				</ExcelSheet>
			</ExcelFile>
		</Box>
	);
}
